

















































































































































































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Promotion from "@/components/Promotion.vue";
import BaseMap from "@/components/BaseMap.vue";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import info from "@/info";
import moment from "moment";
import axios from "axios";
import parser from "fast-xml-parser";
  import Swal from 'sweetalert2'

Vue.component('v-select', vSelect)

@Component({
  components: {
    Navbar,
    Footer,
    BaseMap,
    vSelect
  },
})
export default class Contacto extends Vue {

  options: any;
  terms = false;
  sending = false;
  
  public contactoForm = {
    nombre: '',
    apellido: '',
    correo: '',
    telefono: '',
    interes: '',
    version: '',
    horario_contacto: '',
    auto_selected: {
      name: '',
      year: ''
    },
  };

  public vehicles_list = [
      {
        name: "CIAZ2023",
        year: '2023',
        image: "CIAZ2021.png",
        versions: [          
          {name: "GLX", transmisions: ["Automático"] },          
        ]
      },
      {
        name: "IGNIS2023",
        image: "ignis2021.png",
        year: '2023',
        versions: [
          {name: "GL", transmisions: ["Manual", "CVT"] },
          {name: "GLX", transmisions: ["Manual", "CVT"] },
        ]
      },
      {
        name: "ERTIGA BOOSTERGREEN",
        image: "ertiga-boostergreen.png",
        year: '2023',
        versions: [
          {name: "GLS", transmisions: ["Automático"] },
          {name: "GLX", transmisions: ["Automático"] },
        ]
      },
      {
        name: "ERTIGAXL7",
        image: "ERTIGA-XL72021.png",
        year: '2023',
        versions: [
          {name: "XL7", transmisions: ["Automático"] }
        ]
      },
      {
        name: "S-CROSS",
        image: "s-cross.png",
        year: '2023',
        versions: [
          {name: "GLX", transmisions: ["Automático"]},
          {name: "BOOSTERJET", transmisions: ["Automático"]},
        ]
      },      
      {
        name: "SWIFT2023",
        year: '2023',
        image: "SWIFT-2021.png",
        versions: [
          {name: "GLS", transmisions: ["Manual", "CVT"]},
          {name: "GLX", transmisions: ["Manual", "CVT"]},
          {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
        ]
      },
      {
        name: "SWIFT-SPORT2023",
        year: '2023',
        image: "swift-sport.png",
        versions: [
          {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
        ]
      },
      {
        name: "JIMNY",
        versions: [
          {name: "GLX", transmisions: ["Manual", "Automático"]},
        ]
      },
      {
        name: "GRAND VITARA BOOSTERGREEN",
        versions: [
          {name: "GLX", transmisions: ["Automático"]},
        ]
      },
      {
        name: "FRONX BOOSTERGREEN GLX",
        versions: [
          {name: "GLX", transmisions: ["Automático"]},
        ]
      },
      {
        name: "ERTIGA XL7 BOOSTERGREEN",
        versions: [
          {name: "GLX", transmisions: ["Automático"]},
        ]
      },
      {
        name: "NUEVO SWIFT BOOSTERGREEN",
        image: "nuevo-swift-boostergreen.png",
        year: '2025',
        versions: [
          {name: "GLS", transmisions: ["Manual", "CVT"] },
          {name: "GLX", transmisions: ["Manual", "CVT"] },
        ]
      },

    ]

  public showModal (): void {
    this.$modal.show("hello-world",{},{
      height: 'auto',
      scrollable: true
    });
  }

  get versions(): any {
    let v = this.vehicles_list.filter( (i) => { return i.name == this.contactoForm.auto_selected.name })[0];
    if(v){
      return v.versions
    }else{
      return []
    }
  }

  
  formularioValido(){
    return this.contactoForm.nombre != "" &&
    this.contactoForm.apellido != "" &&
    this.contactoForm.correo != "" &&
    this.contactoForm.telefono != "" &&
    this.contactoForm.horario_contacto != "" &&
    this.contactoForm.interes != "" &&
    this.contactoForm.version != ""    
  }


  created() {
    this.options = this.vehicles_list.map( (i) => {      
      return {
        name: i.name,
        val: i.name,
        img: i.image
      }
    })
  }

  idprefix = "";
  comments = "";
  cf_version = "";

  public sendForm(ev:any){

      ev.preventDefault();

      if(!this.formularioValido()){
        // todo mensaje asegurate de llenar todos los campos
        return;
      }

      let idlead = "";
      if(this.idprefix){
        idlead = "SDW-"+this.idprefix+Date.now();
      }else{
        idlead = "SDW-"+Date.now();
      };

      let requestdate = moment().format('YYYY:MM:DD HH:mm:ss');

      this.comments +=
        this.contactoForm.horario_contacto ? "Horario de contacto: "+this.contactoForm.horario_contacto+" " : "",
        this.contactoForm.interes ? "Interes: "+this.contactoForm.interes+" " : ""

        var xmlData = `<?xml version="1.0" encoding="UTF-8"?>
        <adf>
           <prospect status="new">
              <id>${idlead}</id>
              <requestdate>${requestdate}</requestdate>
              <vehicle interest="buy" status="new">
                 <make>SUZUKI</make>
                 <year>${this.contactoForm.auto_selected.year}</year>
                 <model>${this.contactoForm.auto_selected.name}</model>
                 <trim>${this.contactoForm.version}</trim>
                 <transmision></transmision>
                 <colorcombination>
                   <interiorcolor></interiorcolor>
                   <exteriorcolor></exteriorcolor>
                 </colorcombination>
              </vehicle>
              <customer>
                 <contact>
                    <name part="full">${this.contactoForm.nombre} ${this.contactoForm.apellido}</name>
                    <email>${this.contactoForm.correo}</email>
                    <phone>${this.contactoForm.telefono}</phone>
                 </contact>
                 <origin>${this.contactoForm.interes}</origin>
                 <comments>${this.comments}</comments>
                 <address type="home">
                  <city></city>
                  <postalcode></postalcode>
                  <country>Zacatecas</country>
                 </address>
              </customer>
              <vendor>
                 <id source="inovatix">097914</id>
                 <vendorname>Suzuki Zacatecas</vendorname>
                 <city>Calz. Héroes de Chapultepec 1602, Heroes de Chapultepec, 98040 Zacatecas, Zac.</city>
              </vendor>
           </prospect>
           <provider>
              <name>inovatix</name>
           </provider>
        </adf>
      `;

        // TODO SWITCH PROD URL
        const urlProd = 'https://www.sicopweb.com/interface/adf/add/prospect.xml'
        const urlTest =  'https://www.answerspip.com/interface/adf/add/prospect.xml'

        this.sending = true;
        axios.post( urlTest,
            xmlData,
            {headers:
                  { 
                    'X-API-KEY': 'ZDFhNGE1MzBhYjljNzAwNjYxODg0ZmVmYzY3Y2FiZWM=',
                    'Content-Type': 'application/xml',

                  }
            }).then( res => {

              this.sending = false;
              var xmlResponseString = res.data;
              console.log("res", res)
              var jsonResponse = parser.parse(xmlResponseString);
                  Swal.fire({
                    title: 'Se ha envíado la información de manera correcta',
                    text: jsonResponse.adfresponselist.adfresponse.prospectstatus,
                    icon: 'success',
                    confirmButtonText: 'Ok'
                  }).then( (r) => {
                    location.reload();
                  })
              if(jsonResponse.adfresponselist.adfresponse.adfstatus == "Error"){
                Swal.fire({
                  title: 'Error!',
                  text: jsonResponse.adfresponselist.adfresponse.prospectstatus,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }else{

              }

        }).catch( err => {

          // TODO SAVE LOG
          console.log(err);

        });


    }

}
